module.exports = __webpack_public_path__ + "img/symbol_3.dc7ef7f9.png";